export const LOAD_RESULTS = 'results/LOAD_RESULTS';
export const LOAD_JURISDICTION_RESULTS = 'results/LOAD_JURISDICTION_RESULTS';
export const LOAD_INDIVIDUAL_RESULT = 'results/LOAD_INDIVIDUAL_RESULT';
export const CLEAR_RESULTS = 'results/CLEAR_RESULTS';
export const TOGGLE_JURISDICTION_LOADING = 'results/TOGGLE_JURISDICTION_LOADING';
export const REMOVE_SEARCH_OBJ_RESULTS = 'results/REMOVE_SEARCH_OBJ_RESULTS';

export { REMOVE_SEARCH } from '../searchObjects/types';
